import { memo } from 'react'

interface AmbientOrbsProps {
  variant?: 'default' | 'academy' | 'prompts'
  className?: string
}

const orbConfigs = {
  default: [
    {
      className: 'top-[90px] left-[26%] w-[210px] h-[210px]',
      gradient: 'from-indigo-500/25 to-transparent',
    },
    {
      className: 'top-[180px] right-[8%] w-[260px] h-[260px]',
      gradient: 'from-pink-500/15 to-transparent',
    },
    {
      className: 'bottom-[80px] left-[44%] w-[220px] h-[220px]',
      gradient: 'from-sky-500/15 to-transparent',
    },
  ],
  academy: [
    {
      className: 'top-[60px] left-[20%] w-[240px] h-[240px]',
      gradient: 'from-indigo-500/30 to-transparent',
    },
    {
      className: 'top-[200px] right-[12%] w-[280px] h-[280px]',
      gradient: 'from-cyan-500/18 to-transparent',
    },
    {
      className: 'bottom-[60px] left-[50%] w-[200px] h-[200px]',
      gradient: 'from-emerald-500/12 to-transparent',
    },
  ],
  prompts: [
    {
      className: 'top-[88px] left-[42%] w-[180px] h-[180px]',
      gradient: 'from-indigo-500/30 to-transparent',
    },
    {
      className: 'top-[230px] right-[10%] w-[220px] h-[220px]',
      gradient: 'from-pink-500/18 to-transparent',
    },
    {
      className: 'bottom-[90px] left-[24%] w-[240px] h-[240px]',
      gradient: 'from-sky-500/18 to-transparent',
    },
  ],
} as const

export const AmbientOrbs = memo(function AmbientOrbs({
  variant = 'default',
  className = '',
}: AmbientOrbsProps) {
  const orbs = orbConfigs[variant]

  return (
    <div
      className={`pointer-events-none fixed inset-0 z-0 overflow-hidden ${className}`}
      aria-hidden
    >
      {orbs.map((orb, i) => (
        <div
          key={i}
          className={`bg-radial-gradient absolute rounded-full opacity-55 blur-[16px] ${orb.className}`}
          style={Object.assign(
            {},
            {
              background: `radial-gradient(circle, var(--tw-gradient-stops))`,
            },
          )}
        >
          <div className={`h-full w-full rounded-full bg-gradient-to-br ${orb.gradient}`} />
        </div>
      ))}
    </div>
  )
})
